// @ts-nocheck
import { isDomainMatch } from '../utilities/nodes';

export function checkDomain(domainsSet) {
  const { hostname } = window.location;
  const isValid = isDomainMatch(hostname, domainsSet);

  if (!isValid) {
    // eslint-disable-next-line no-console
    console.warn(`Site client on invalid domain: ${hostname}`);
  }

  return isValid;
}
